import { render, staticRenderFns } from "./HygieneOpportunities.vue?vue&type=template&id=7fe2fcd2"
import script from "./HygieneOpportunities.vue?vue&type=script&lang=js"
export * from "./HygieneOpportunities.vue?vue&type=script&lang=js"
import style0 from "./HuddleComponentsModern.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports